<!--
 * @Author: wjc
 * @Date: 2023-11-15 09:54:21
 * @LastEditors: wjc
 * @LastEditTime: 2026-03-24 11:41:30
 * @Description: 
-->
<template>
  <NuxtLayout>
    <el-config-provider :size="elConfig.size" :z-index="elConfig.zIndex" :locale="zhCn">
      <NuxtPage />
    </el-config-provider>
  </NuxtLayout>
</template>

<script setup lang="ts">
  import zhCn from 'element-plus/es/locale/lang/zh-cn'

  import { themeVar } from '~/utils/colors'
  import { appName } from '~/utils/constants'
  import { updateMainColorVariables } from '~/utils/css-var'

  useHead({
    title: appName,
  })

  const elConfig = ref<{
    size: 'default' | 'large' | 'small'
    zIndex: number
  }>({
    size: 'default',
    zIndex: 300,
  })

  onBeforeMount(() => {
    updateMainColorVariables(themeVar)
  })
</script>

<style lang="scss">
  html,
  body,
  /* stylelint-disable-next-line selector-id-pattern */
  #__nuxt {
    height: 100%;
    padding: 0;
    margin: 0;
  }
</style>
